import React from 'react';
import { Box, Stack } from '@mui/material';
import AddCategoryButton from './Common/AddCategoryButton';
// import StoreCategoryModal from './Modals/StoreCategoryModal';
import ItemCategoryModal from './Modals/ItemCategoryModal';
import ItemSubCategoryModal from './Modals/ItemSubCategoryModal';

interface AccordionProps {
  buttonMode: 'itemSubCategory' | 'itemCategory' | 'addStoreCategory';
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  mode: 'add' | 'edit';
  initialData: {
    storeType: string | undefined;
    storeId: string | undefined;
    id: string;
    englishName: string;
    arabicName: string;
    addedBy: string;
    categoryImage: string;
    categoryIcon: string;
  } | null;
  handleAddCategory: () => void;
  expanded?: boolean;
  setExpanded?: React.Dispatch<React.SetStateAction<boolean>>;
  sx?: any;
}

const Accordion: React.FC<AccordionProps> = ({
  buttonMode,
  open,
  setOpen,
  mode,
  initialData,
  handleAddCategory,
  sx,
}) => {
  return (
    <Box sx={sx}>
      <Stack spacing={2}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
        >
          <AddCategoryButton
            onClick={handleAddCategory}
            loading={false}
            mode={buttonMode}
            open={false}
          />
        </Stack>
        {/* 
        {buttonMode === 'addStoreCategory' && (
          <StoreCategoryModal
            open={open}
            setOpen={setOpen}
            mode={mode}
            initialData={
              initialData
                ? {
                    id: initialData.id,
                    englishName: initialData.englishName,
                    arabicName: initialData.arabicName,
                    categoryImage: initialData.categoryImage,
                    categoryIcon: initialData.categoryIcon,
                    addedBy: initialData.addedBy,
                  }
                : null
            }
          />
        )} */}

        {buttonMode === 'itemCategory' && (
          <ItemCategoryModal
            open={open}
            setOpen={setOpen}
            mode={mode}
            initialData={
              initialData
                ? {
                  id: initialData.id,
                  englishName: initialData.englishName,
                  arabicName: initialData.arabicName,
                  addedBy: initialData.addedBy,
                  storeId: initialData.storeId,
                  storeType: initialData.storeType,
                }
                : null
            }
          />
        )}

        {buttonMode === 'itemSubCategory' && (
          <ItemSubCategoryModal
            open={open}
            setOpen={setOpen}
            mode={mode}
            initialData={
              initialData
                ? {
                  id: initialData.id,
                  englishName: initialData.englishName,
                  arabicName: initialData.arabicName,
                  addedBy: initialData.addedBy,
                }
                : null
            }
          />
        )}
      </Stack>
    </Box>
  );
};

export default Accordion;
